export default __webpack_public_path__ + "5127f5a3862a2d4b47d2ce4c127e1114.svg";